import Reveal from '@/components/feature/Reveal';
import { chatMessages, discussionGroups } from '@/mocks/home';

export default function ChatLounge() {
  return (
    <section id="lounge" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-secondary-700 uppercase">
            <i className="ri-chat-3-line" /> 讨论群
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-5xl font-black leading-tight text-foreground-950">
            老哥实时开聊，进来就有座位
          </h2>
          <p className="mt-4 md:max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
            46 个讨论群同时在线，从公共区大群到时间线复盘组，挑一个频道坐下，先说一句话就算入场。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1.35fr_1fr] gap-6 md:gap-8">
          <Reveal>
            <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden h-full">
              <div className="flex items-center gap-3 px-5 md:px-6 h-14 border-b border-background-200 bg-background-50">
                <span className="w-9 h-9 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center">
                  <i className="ri-chat-smile-2-line" />
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-950">公共区大群</p>
                  <p className="text-xs text-foreground-500">1,286 人在线 · 正在热聊</p>
                </div>
                <span className="ml-auto inline-flex items-center gap-1.5 text-xs font-bold text-secondary-700 whitespace-nowrap">
                  <span className="w-2 h-2 rounded-full bg-secondary-500 animate-pulse" /> 直播中
                </span>
              </div>

              <div className="p-4 md:p-5 flex flex-col gap-4">
                {chatMessages.map((msg) => (
                  <div key={`${msg.user}-${msg.time}`} className="flex items-start gap-3">
                    <span className="w-9 h-9 shrink-0 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-sm font-bold">
                      {msg.user.slice(0, 1)}
                    </span>
                    <div className="min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-xs font-bold text-foreground-900">{msg.user}</span>
                        <span className="text-xs text-foreground-400">{msg.time}</span>
                      </div>
                      <p className="mt-1.5 text-sm leading-relaxed text-foreground-700 bg-background-50 border border-background-200 rounded-md rounded-tl-none px-3.5 py-2.5">
                        {msg.text}
                      </p>
                    </div>
                  </div>
                ))}
                <div className="mt-1 flex items-center gap-3 rounded-md border border-dashed border-background-300 bg-background-50 px-4 py-3">
                  <i className="ri-chat-new-line text-foreground-400" />
                  <span className="text-sm text-foreground-400">说点什么，和大家一起开聊…</span>
                  <button
                    type="button"
                    className="ml-auto h-8 px-4 rounded-full bg-primary-500 text-background-50 text-xs font-bold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
                  >
                    发送
                  </button>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="flex flex-col gap-4">
              <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">热门讨论群</h3>
                  <a href="#fanclub" className="text-xs font-bold text-primary-600 whitespace-nowrap">
                    全部 46 个 <i className="ri-arrow-right-s-line" />
                  </a>
                </div>
                <div className="flex flex-col gap-3">
                  {discussionGroups.map((group) => (
                    <div
                      key={group.name}
                      className="flex items-center gap-4 rounded-md border border-background-200 bg-background-50 px-4 py-3.5 hover:border-secondary-300 transition-colors"
                    >
                      <div className="min-w-0 flex-1">
                        <div className="flex items-center gap-2 flex-wrap">
                          <p className="text-sm font-bold text-foreground-950">{group.name}</p>
                          <span className="h-5 px-2 inline-flex items-center rounded-full bg-accent-100 text-accent-900 text-[11px] font-bold whitespace-nowrap">
                            {group.tag}
                          </span>
                        </div>
                        <p className="mt-1 text-xs text-foreground-500 truncate">{group.desc}</p>
                      </div>
                      <div className="text-right shrink-0">
                        <p className="text-xs font-bold text-secondary-700 whitespace-nowrap">{group.online} 在线</p>
                        <span className="text-xs font-bold text-primary-600 whitespace-nowrap cursor-pointer">加入</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-5 md:p-6">
                <p className="text-xs font-bold tracking-[0.2em] text-secondary-700 uppercase">群规速览</p>
                <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-700">
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-secondary-600 mt-0.5" /> 先看置顶，再开麦
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-secondary-600 mt-0.5" /> 只聊细节，不吹不黑
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-secondary-600 mt-0.5" /> 有新料记得 @ 全场
                  </li>
                </ul>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}